/**
 * Resolve redeem instructions for a prize.
 * Priority: prize.description → matching campaign prize description → campaign.redeemInstructions
 */
export function getRedeemInstructions(prize, campaign) {
  const fromPrize = prize?.description?.trim();
  if (fromPrize) return fromPrize;

  const fromCampaignPrize = campaign?.prizes
    ?.find((p) => p.name === prize?.name)?.description?.trim();
  if (fromCampaignPrize) return fromCampaignPrize;

  return (
    campaign?.redeemInstructions ||
    prize?.campaign?.redeemInstructions ||
    'Contacta con el establecimiento'
  );
}
